exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addTitlePick{min-height:350px}.addTitlePick .manualForm{text-align:center}.addTitlePick .manualForm .buttonSuccess{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/picks/add_title_pick.scss
// module id = 1396
// module chunks = 0